import React from "react";
import { Button } from "../../common/Button/Button";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { filter, orderBy } from "lodash";
// import find from 'lodash/find'

export default function UserTable(props) {

	const columns = 
	[
		{
			id: "name",
			Header: "Name",
			accessor: "",
			Cell: ({ original: { first_name, last_name } }) => {
				let label = "-";
				if (first_name) label = first_name;
				if (last_name) label += " " + last_name;
				return label;
			},
		},

		{ id: "email", Header: "Email", accessor: "email" },
		{
			id: "is_active",
			Header: "Status",
			accessor: "",
			Cell:({ original: { is_active, out_of_office }}) => {
				if (is_active === false) return "Deactivated";
				else if(out_of_office === true) return "Out of office";
				else return ("Active");		
			},
		},
		{
			id: "role",
			Header: "User Role",
			accessor: "",
			Cell: ({ original: { role } }) => {
				const temp = role.map(i=>{
					return props.roles[i]+", ";
				})				
				return temp;
			},
		},
	];
	return (
		<ReactTable
			data={props.data || []}
			columns={columns}
			manual
			showPagination={false}
			style={{
				overflowY: "auto",
				height: "800px"}}
			getTdProps={(state, rowInfo, column) => {
				if (column && column.id !== "checkbox") {
					return {
						onClick: (e) => props.onUserRowClick(rowInfo),
					};
				} else {
					return { onClick: (e, h) => h() };
				}
			}}
			NextComponent={(instance) => (
				<Button className="mt3" {...instance}>
					Next
				</Button>
			)}
			PreviousComponent={(instance) => (
				<Button className="mt3" {...instance}>
					Previous
				</Button>
			)}
		/>
	);
}
